/**
 * Список проектов §78.
 */
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Plus } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { EmptyState } from '../../components/ui/EmptyState';
import { PageHeader } from '../../components/ui/PageHeader';
import { StatusDot } from '../../components/ui/StatusDot';
import { projectsApi } from '../../api/projects';
import { useTranslation } from 'react-i18next';

export function ProjectsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const projects = useQuery({ queryKey: ['projects'], queryFn: projectsApi.list });
  const items = projects.data ?? [];

  return (
    <div>
      <PageHeader
        title={t('projects.title')}
        action={
          <Button variant="primary" onClick={() => navigate('/create')}>
            <Plus className="h-4 w-4" strokeWidth={2} />{t('projects.createVideo')}</Button>
        }
      />

      {items.length === 0 && !projects.isLoading ? (
        <EmptyState
          title={t('projects.empty.title')}
          description={t('projects.empty.description')}
          action={
            <Button variant="primary" onClick={() => navigate('/create')}>{t('projects.createVideo')}</Button>
          }
        />
      ) : (
        <div className="flex flex-col gap-3">
          {items.map((project) => (
            <button
              key={project.id}
              type="button"
              onClick={() => navigate(`/projects/${project.id}`)}
              className="flex items-center gap-4 rounded-card border border-line bg-surface px-4 py-3.5 text-left transition-colors duration-fast hover:border-line-strong"
            >
              <StatusDot
                tone={
                  project.status === 'ready'
                    ? 'ok'
                    : project.status === 'failed'
                      ? 'fail'
                      : project.status === 'storyboard'
                        ? 'idle'
                        : 'warn'
                }
              />
              <div className="min-w-0 flex-1">
                <p className="truncate text-body text-content">{project.title}</p>
                <p className="text-meta text-content-muted">
                  {t(`enum.projectStatus.${project.status}`, {
                    defaultValue: project.statusLabel,
                  })}{' '}
                  · {t('projects.seconds', { count: project.durationSec })} ·{' '}
                  {t('billing.unitsPlural', { count: project.estimatedUnits })}
                </p>
              </div>
              <span className="text-meta text-content-muted">{project.aspectRatio}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
